import { Statistic, Table} from 'antd'

import React, {useState, useEffect} from 'react'



function ClaimTableTwitter() {
    const [result, setResult] = useState([])
    const [loading, setLoading] = useState(false)

    const columns = [
      {
        title: 'Date claim',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (d) => new Date(d['$date']).toLocaleDateString() + " " + new Date(d['$date']).toLocaleTimeString()
      },
      {
        title: 'XDG Claimed',
        dataIndex: 'amountSent',
        key: 'amountSent',
      },
      {
        title: 'DogeNano Hash',
        dataIndex: 'hash',
        key: 'hash',
        render: (r) => <a href={'https://nanexplorer.com/dogenano/blocks/'+r}>View</a>
      },
      {
        title: 'X Post',
        dataIndex: 'tweetId',
        key: 'tweetId',
        render: (r) => <a href={'https://twitter.com/i/status/'+r}>View</a>
      },
   
      {
        title: 'X Author Id',
        dataIndex: 'tweetAuthorId',
        key: 'tweetAuthorId',
        render: (r) => <a href={'https://x.com/i/user/'+r}>View</a>
      },
      {
        title: 'DogeNano Address',
        dataIndex: 'address',
        key: 'address',
      },
    ];
    
    useEffect(() => {
      setLoading(true)
      Promise.all([
        import('./distribution-data/twitter.claims.json'),  
        import('./distribution-data/twitter.claims.2.json'),
      ]).then((r) => {
        const data = [...r[0].default, ...r[1].default]
        // sort by date
        data.sort((a,b) => new Date(b.createdAt['$date']) - new Date(a.createdAt['$date']))
        setResult(data)
        setLoading(false)
      })
        
    }, [])
    
  return (
    <div>
    <b>Total:</b> {result.reduce((a, b) => a + b.amountSent, 0).toLocaleString('en-US')} XDG<br/>
      <Table
      size='small'
      pagination={{defaultPageSize: 5}}
       loading={loading} scroll={{x: true}} dataSource={result} columns={columns} />
    </div>
  )
}

export default ClaimTableTwitter